<nz-form-item class="{{parameters.data?.class}}">
  <nz-form-label [nzRequired]="parameters.data?.label.required">{{ parameters.data?.label.text | translate }}
    <i nz-icon nzType="{{parameters.data?.label.type }}" nz-tooltip nzTheme="outline"
      nzTooltipTitle="{{parameters.data?.label.tooltip | translate}}" class="{{parameters.data?.label.class}}"></i>
  </nz-form-label>


  <nz-form-control [nzErrorTip]="errorTemplate">
    <ng-container [ngSwitch]="inputType()">
      <!-- INPUT -->
      <ng-container *ngSwitchCase="wrapFormItemEnum.INPUT">
        <input nz-input id="{{parameters.data?.formcontrol[inputType()].name}}"
          formControlName="{{parameters.data?.formControl[inputType()].name}}"
          pattern="{{parameters.data?.formControl[inputType()].pattern}}"
          placeholder="{{parameters.data?.formControl[inputType()].placeholder | translate}}">
      </ng-container>
      <!-- TEXTAREA -->
      <ng-container *ngSwitchCase="wrapFormItemEnum.TEXTAREA">
        <textarea id="{{parameters.data?.formControl[inputType()].name}}"
          formControlName="{{parameters.data?.formControl[inputType()].name}}" nz-input
          rows="{{parameters.data?.formControl[inputType()].rows}} ||  2"
          placeholder="{{ parameters.data?.formControl[inputType()].placeholder | translate }}"
          maxlength="{{parameters.data?.formControl[inputType()].maxlength}}"></textarea>
      </ng-container>
      <!-- SELECT -->
      <ng-container *ngSwitchCase="wrapFormItemEnum.SELECT">
        <nz-select [nzSize]="parameters.data?.formControl[inputType()].size" nzShowSearch
          id="{{parameters.data?.formControl[inputType()].name}}"
          formControlName="{{parameters.data?.formControl[inputType()].name}}" nzAllowClear>
          <nz-option *ngFor="let option of parameters.data?.formControl[inputType()].options.source"
            [nzLabel]="parameters.data?.formControl[inputType()].options.label"
            [nzValue]="parameters.data?.formControl[inputType()].options.label">
          </nz-option>
        </nz-select>
      </ng-container>
    </ng-container>

    <!-- ERROR HANDLER -->
    <ng-template #errorTemplate let-control>
      <ng-container *ngIf="control.hasError('required')">
        {{'sez.validation.required' | translate}}
      </ng-container>
      <ng-container *ngIf="control.hasError('pattern')">
        {{'sez.business-reg.validation.name' | translate}}
      </ng-container>
      <ng-container *ngIf="control.hasError('maxlength')">
        Business Description should be less than {{parameters.data?.form?.maxlength || 255}} Characters.
      </ng-container>
    </ng-template>
  </nz-form-control>

</nz-form-item>
